"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function MetaformFilterFromJSON(json) {
    return MetaformFilterFromJSONTyped(json, false);
}
exports.MetaformFilterFromJSON = MetaformFilterFromJSON;
function MetaformFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'fields': !runtime_1.exists(json, 'fields') ? undefined : json['fields'],
    };
}
exports.MetaformFilterFromJSONTyped = MetaformFilterFromJSONTyped;
function MetaformFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'fields': value.fields,
    };
}
exports.MetaformFilterToJSON = MetaformFilterToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1GaWx0ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvTWV0YWZvcm1GaWx0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSCx3Q0FBK0M7QUEyQi9DLFNBQWdCLHNCQUFzQixDQUFDLElBQVM7SUFDNUMsT0FBTywyQkFBMkIsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDcEQsQ0FBQztBQUZELHdEQUVDO0FBRUQsU0FBZ0IsMkJBQTJCLENBQUMsSUFBUyxFQUFFLG1CQUE0QjtJQUMvRSxJQUFJLENBQUMsSUFBSSxLQUFLLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxFQUFFO1FBQ3pDLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUM7UUFDaEIsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDcEIsUUFBUSxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQztLQUNqRSxDQUFDO0FBQ04sQ0FBQztBQVZELGtFQVVDO0FBRUQsU0FBZ0Isb0JBQW9CLENBQUMsS0FBNkI7SUFDOUQsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3JCLE9BQU8sU0FBUyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsSUFBSSxFQUFFLEtBQUssQ0FBQyxFQUFFO1FBQ2QsTUFBTSxFQUFFLEtBQUssQ0FBQyxJQUFJO1FBQ2xCLFFBQVEsRUFBRSxLQUFLLENBQUMsTUFBTTtLQUN6QixDQUFDO0FBQ04sQ0FBQztBQWJELG9EQWFDIn0=